import { Dashboard_WorkloadType, Dashboard_InitiatorType, Dashboard_WorkloadsHoursDuration } from '@/graphql/codegen/generated/graphql';

export const hoursIndexMap: Record<number, string> = {
  0: '00:00',
  1: '01:00',
  2: '02:00',
  3: '03:00',
  4: '04:00',
  5: '05:00',
  6: '06:00',
  7: '07:00',
  8: '08:00',
  9: '09:00',
  10: '10:00',
  11: '11:00',
  12: '12:00',
  13: '13:00',
  14: '14:00',
  15: '15:00',
  16: '16:00',
  17: '17:00',
  18: '18:00',
  19: '19:00',
  20: '20:00',
  21: '21:00',
  22: '22:00',
  23: '23:00',
};

export const dayMap: Record<Exclude<keyof Dashboard_WorkloadsHoursDuration, '__typename'>, number> = {
  Monday: 6,
  Tuesday: 5,
  Wednesday: 4,
  Thursday: 3,
  Friday: 2,
  Saturday: 1,
  Sunday: 0,
};

export const indexDayMap = Object.entries(dayMap).reduce((acc, [key, value]) => {
  acc[value] = key as keyof Dashboard_WorkloadsHoursDuration;
  return acc;
}, {} as Record<number, keyof Dashboard_WorkloadsHoursDuration>);

export const workloadTypesLabels: Record<Dashboard_WorkloadType, string> = {
  [Dashboard_WorkloadType.Build]: 'Build',
  [Dashboard_WorkloadType.Rebuild]: 'Rebuild',
  [Dashboard_WorkloadType.Clean]: 'Clean',
  [Dashboard_WorkloadType.Unknown]: 'Unknown',
};
export const initiatorTypesLabels: Record<Dashboard_InitiatorType, string> = {
  [Dashboard_InitiatorType.Ci]: 'CI',
  [Dashboard_InitiatorType.Developer]: 'Developer',
  [Dashboard_InitiatorType.MissingLicense]: 'None',
};
export const targetBaseTimeMap = {
  seconds: 'Time [sec]',
  minutes: 'Time [min]',
  hours: 'Time [hr]',
};
